export const getAddonCategories = (availableAddons) => {
  const addonCategories = availableAddons.reduce((acc, curr) => {
    if (acc[curr.shortName]) {
      return { ...acc, ...{ [curr.shortName]: [...acc[curr.shortName], curr] } };
    }
    return { ...acc, ...{ [curr.shortName]: [curr] } };
  }, {});
  return addonCategories;
};
